import React, { useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';

import CustomModal from '../../../../../../../shared/components/v3/Modals/CustomModal/CustomModal';
import {
  COLLABORATOR_ID_BY_COUNTRY,
  DEPENDENTS_ID_BY_COUNTRY,
  DEPENDENTS_INFORMATIVE_MODAL_ITEMS
} from '../../../../../../../shared/constants/manageCollaborators';
import { TRANSLATION_MANAGE_COLLABORATORS } from '../../../../../../../shared/translations/manageCollaborators';

import './DependentsInformativeModal.scss';

interface DependentsInformativeModalProps {
  countryCode: string;
}

const DependentsInformativeModal = ({ countryCode }: DependentsInformativeModalProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [items] = useState<string[][]>(DEPENDENTS_INFORMATIVE_MODAL_ITEMS);
  const { t } = useTranslation();

  const handleClick = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <button onClick={handleClick} className="adbf-helper-button">
        {t(TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.addDependentsByFile.helperButton)}
      </button>
      <CustomModal open={openModal} onClose={closeModal} customClass="adbf-custom-modal">
        <div className="adbf-informative-modal">
          <div className="dependents-informative-modal-title">
            {t(TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.addDependentsByFile.informativeModal.title)}
          </div>
          <div className="dependents-informative-modal-description">
            {t(TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.addDependentsByFile.informativeModal.description)}
          </div>
          <div className="dependents-informative-modal-items">
            {items.map((itemsList) => (
              <div className="dependents-informative-modal-items-column" key={uuid()}>
                {itemsList.map((item) => (
                  <li key={item} style={{ listStylePosition: 'inside' }}>
                    {t(item, {
                      interpolation: { escapeValue: false },
                      ID_TYPE: DEPENDENTS_ID_BY_COUNTRY[countryCode as keyof typeof DEPENDENTS_ID_BY_COUNTRY],
                      collabIdType: COLLABORATOR_ID_BY_COUNTRY[countryCode as keyof typeof COLLABORATOR_ID_BY_COUNTRY]
                    }).toUpperCase()}
                  </li>
                ))}
              </div>
            ))}
          </div>
          <div className="dependents-informative-card">
            <Trans
              i18nKey={TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.addDependentsByFile.informativeModal.infoCard}
              components={{
                b: <b></b>,
                br: <br />
              }}
            />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default DependentsInformativeModal;
